module.exports = __webpack_public_path__ + "static/img/password.bcb21d51.png";